/**
 *  The type of Role Permission.
 */
export enum RolePermissionType {
  /**
   * Overview Entity Activity.
   */
  Overview_Activity = 'overview/activity',

  /**
   * Overview Entity Statistics.
   */
  Overview_Statistics = 'overview/statistics',

  /**
   * Access and manage Seniors list.
   */
  Seniors_List = 'seniors/list',

  /**
   * Access Seniors Dashboard.
   */
  Seniors_Dashboard = 'seniors/dashboard',

  /**
   * Access and manage Seniors Dashboard Activity.
   *
   * @note This screen previously was in `{senior}/personal-data/activity` path
   * and it was moved later to `{senior}/dashboard/activity`.
   */
  Seniors_Dashboard_Activity = 'seniors/personal-data/activity',

  /**
   * Access and manage Seniors Dashboard for General Statistics.
   */
  Seniors_Dashboard_GeneralStatistics = 'seniors/dashboard/general-statistics',

  /**
   * Access and manage Seniors Dashboard for Health Statistics.
   */
  Seniors_Dashboard_HealthStatistics = 'seniors/dashboard/health-statistics',

  /**
   * Access and manage Seniors Personal Data Profile.
   */
  Seniors_PersonalData_Profile = 'seniors/personal-data/profile',

  /**
   * Access and manage Seniors Personal Data Caregivers.
   */
  Seniors_PersonalData_Caregivers = 'seniors/personal-data/caregivers',

  /**
   * Access and manage Seniors Personal Data Health.
   */
  Seniors_PersonalData_Health = 'seniors/personal-data/health',

  /**
   * Access and manage Seniors Personal Attachments.
   */
  Seniors_PersonalData_Attachments = 'seniors/personal-data/attachments',

  /**
   * Access and manage Seniors Basic Activities of Daily Life.
   */
  Seniors_BADL = 'seniors/badl',

  /**
   * Access and manage Seniors Instrumental Activities of Daily Living.
   */
  Seniors_IADL = 'seniors/iadl',

  /**
   * Access and manage Seniors Clinical Support activities.
   */
  Seniors_ClinicalSupport = 'seniors/clinical-support',

  /**
   * Access and manage Seniors Personal Development activities.
   */
  Seniors_PersonalDevelopment = 'seniors/personal-development',

  /**
   * Access and manage Seniors Care Summary.
   */
  Seniors_CareAndActivities = 'seniors/care-and-activities',

  /**
   * Access and manage Seniors Care Summary of Basic Activities of Daily Life.
   */
  Seniors_CareAndActivities_BADL = 'seniors/care-and-activities/badl',

  /**
   * Access and manage Seniors Care Summary of Instrumental Activities of Daily Living.
   */
  Seniors_CareAndActivities_IADL = 'seniors/care-and-activities/iadl',

  /**
   * Access and manage Seniors Care Summary of Clinical Support.
   */
  Seniors_CareAndActivities_ClinicalSupport = 'seniors/care-and-activities/clinical-support',

  /**
   * Access and manage Seniors Care Summary of Personal Development.
   */
  Seniors_CareAndActivities_PersonalDevelopment = 'seniors/care-and-activities/personal-development',

  /**
   * Access and manage Seniors individual plans.
   */
  Seniors_IndividualPlan = 'seniors/individual-plan',

  /**
   * Access and manage Seniors reminders.
   */
  Seniors_PersonalData_Reminders = 'seniors/personal-data/reminders',

  /**
   * Access and manage Seniors Care Services
   */
  Seniors_CareServices = 'seniors/care-services',

  /**
   * Access and manage Seniors Digital Inclusion Applications.
   */
  Seniors_DigitalInclusion_Applications = 'seniors/personal-data/applications',

  /**
   * Access and manage Seniors Digital Inclusion Devices.
   */
  Seniors_DigitalInclusion_Devices = 'seniors/personal-data/devices',

  /**
   * Access and manage Seniors Digital Inclusion Cards.
   */
  Seniors_DigitalInclusion_Cards = 'seniors/personal-data/cards',

  /**
   * Access and manage Seniors Digital Inclusion Playlists.
   */
  Seniors_DigitalInclusion_Playlists = 'seniors/personal-data/playlists',

  /**
   * Access and manage Professionals list.
   */
  Team_Professionals = 'team/professionals',

  /**
   * Access and manage Team's Care Services.
   */
  Team_CareServices = 'team/care-services',

  /**
   * Access and manage Professional Profile
   */
  Team_Professionals_Profile = 'team/professionals/profile',

  /**
   * Access and manage Professional's Applications.
   */
  Team_Professionals_Applications = 'team/professionals/applications',

  /**
   * Access and manage Professional's Cards.
   */
  Team_Professionals_Cards = 'team/professionals/cards',

  /**
   * Access and manage Professional's Playlists.
   */
  Team_Professionals_Playlists = 'team/professionals/playlists',

  /**
   * Access and manage Professional's Care Services.
   */
  Team_Professionals_CareServices = 'team/professionals/care-services',

  /**
   * Access and manage Team Shifts.
   */
  Team_Shifts_Management = 'team/shifts/management',

  /**
   * Access and manage Team Shifts Attributions.
   */
  Team_Shifts_Attributions = 'team/shifts/attributions',

  /**
   * Manage roles and permissions, attributions, etc.
   */
  Team_Permissions = 'team/permissions',

  /**
   * Access and manage Team Attendance Tracker Registry (the clock in/out records made by professionals).
   */
  Team_AttendanceTracker_Registry = 'team/attendance-tracker/registry',

  /**
   * Access and manage Team Attendance Tracker Assignments (if each professional must, can or does not need to track attendance).
   */
  Team_AttendanceTracker_Assignments = 'team/attendance-tracker/assignments',

  /**
   * Access and manage Entity Profile.
   */
  Settings_Entity_Profile = 'settings/entity/profile',

  /**
   * Access and manage Entity Settings.
   */
  Settings_Entity_Settings = 'settings/entity/settings',

  /**
   * Access and manage Licenses.
   */
  Settings_Licenses = 'settings/licenses',

  /**
   * Access and manage Basic Activities of Daily Life settings.
   */
  Settings_BADL = 'settings/badl',

  /**
   * Access and manage Instrumental Activities of Daily Living settings.
   */
  Settings_IADL = 'settings/iadl',

  /**
   * Access and manage Clinical Support settings.
   */
  Settings_ClinicalSupport = 'settings/clinical-support',

  /**
   * Access and manage Personal Development settings.
   */
  Settings_PersonalDevelopment = 'settings/personal-development',

  /**
   * Access and manage Templates settings.
   */
  Settings_Templates = 'settings/templates',

  /**
   * Access and manage Occurrences types settings.
   */
  Settings_Occurrences = 'settings/occurrences',

  /**
   * Access and manage Quick Access devices.
   */
  SettingsQuickAccessDevices = 'settings/quick-access-devices',

  /**
   * Access and manage Daily Care Log.
   */
  DailyCareLog = 'daily-care-log',

  /**
   * Access and manage Daily Care Log (Basic Activities of Daily Life only).
   */
  DailyCareLog_BADL = 'daily-care-log/badl',

  /**
   * Access and manage Daily Care Log (Instrumental Activities of Daily Living only).
   */
  DailyCareLog_IADL = 'daily-care-log/iadl',

  /**
   * Access and manage Daily Care Log (Clinical Support only).
   */
  DailyCareLog_ClinicalSupport = 'daily-care-log/clinical-support',

  /**
   * Access and manage Daily Care Log (Personal Development only).
   */
  DailyCareLog_PersonalDevelopment = 'daily-care-log/personal-development',

  /**
   * Access and manage Daily Care Log Occurrences.
   */
  DailyCareLog_Occurrences = 'daily-care-log/occurrences',

  /**
   * Access and manage Digital Inclusion Applications.
   */
  DigitalInclusion_Applications = 'digital-inclusion/applications',

  /**
   * Access and manage Digital Inclusion Media.
   */
  DigitalInclusion_Media = 'digital-inclusion/media',

  /**
   * Access and manage Digital Inclusion Devices.
   */
  DigitalInclusion_Devices = 'digital-inclusion/devices',

  /**
   * Access and manage Digital Inclusion Cards.
   */
  DigitalInclusion_Cards = 'digital-inclusion/cards',

  /**
   * Access and manage Digital Inclusion Playlists.
   */
  DigitalInclusion_Playlists = 'digital-inclusion/playlists',

  /**
   * Access and manage Digital Inclusion Services.
   */
  DigitalInclusion_Services = 'digital-inclusion/services',

  /**
   * Access and manage Calendar
   */
  Calendar = 'calendar',

  /**
   * Access and manage Calendar (Basic Activities of Daily Life only).
   */
  Calendar_BADL = 'calendar/badl',

  /**
   * Access and manage Calendar (Instrumental Activities of Daily Living only).
   */
  Calendar_IADL = 'calendar/iadl',

  /**
   * Access and manage Calendar (Clinical Support only).
   */
  Calendar_ClinicalSupport = 'calendar/clinical-support',

  /**
   * Access and manage Calendar (Personal Development only).
   */
  Calendar_PersonalDevelopment = 'calendar/personal-development',

  /**
   * Access and manage Occurrences.
   */
  Occurrences = 'occurrences/list',
}
